function createManagementShortDateMethods({ DateFormatter }) {
  return {
    formatDate(value) {
      return DateFormatter(value).format('YYYY.MM.DD');
    },
  };
}

module.exports = createManagementShortDateMethods;
